/* eslint-disable camelcase */
import Constants from 'expo-constants';
import { injectable } from 'inversify';
import ReactPixel from 'react-facebook-pixel';
import { Platform } from 'react-native';

import type { SignUpMethods } from '~types/analytics';

enum EFacebookPixelServiceEvents {
  completeRegistration = 'COMPLETE_REGISTRATION',
  purchase = 'PURCHASE',
  viewContent = 'VIEW_CONTENT',
}

export type IFacebookPixelTrackPurchaseArgs = {
  /**
   * @description An array<string> containing a single item - the product ID
   */
  contentIds: [string | null]; // This limits the content to a single item - use string[] if we ever support multiple items
  /**
   * @description The name of the product
   */
  contentName: string | null;
  // contentType: string; // Always set to "product"
  contents: {
    /**
     * @description The ID of the product as a string
     */
    id: string;
    /**
     * @description The quantity of the product as a number
     */
    quantity: number;
  }[];
  // numItems: number; = Always set to 1
  /**
   * @description the subtotal of the order (i.e. excluding postage)
   */
  value: number | null;
  // currency: string; = Always set to "GBP"
};

export type IFacebookPixelTrackViewProductDetailsArgs = {
  contentIds: [string | null];
  contentName: string | null;
};

@injectable()
export class FacebookPixelService {
  initialize = () => {
    if (Platform.OS === 'web') {
      if (Constants.manifest?.extra?.facebookPixel.id) {
        ReactPixel.init(Constants.manifest.extra.facebookPixel.id);
        ReactPixel.pageView();
      }
    }
  };

  trackPurchase = ({
    contentIds,
    contentName,
    contents,
    value,
  }: IFacebookPixelTrackPurchaseArgs) => {
    if (Platform.OS === 'web') {
      if (Constants.manifest?.extra?.facebookPixel.id) {
        const data = {
          content_ids: contentIds,
          content_name: contentName,
          content_type: 'product',
          contents,
          num_items: 1,
          value,
          currency: 'GBP',
        };
        ReactPixel.trackSingle(
          Constants.manifest.extra.facebookPixel.id,
          EFacebookPixelServiceEvents.purchase,
          data
        );
      }
    }
  };

  trackCompleteRegistration = (contentName: SignUpMethods) => {
    if (Platform.OS === 'web') {
      if (Constants.manifest?.extra?.facebookPixel.id) {
        const data = {
          status: true,
          value: Number(10).toFixed(2),
          currency: 'GBP',
          content_name: contentName,
        };
        ReactPixel.trackSingle(
          Constants.manifest.extra.facebookPixel.id,
          EFacebookPixelServiceEvents.completeRegistration,
          data
        );
      }
    }
  };

  trackViewProductDetails = ({
    contentIds,
    contentName,
  }: IFacebookPixelTrackViewProductDetailsArgs) => {
    if (Platform.OS === 'web') {
      if (Constants.manifest?.extra?.facebookPixel.id) {
        const data = {
          content_ids: contentIds,
          content_name: contentName,
          content_type: 'product',
          num_items: 1,
        };
        ReactPixel.trackSingle(
          Constants.manifest.extra.facebookPixel.id,
          EFacebookPixelServiceEvents.viewContent,
          data
        );
      }
    }
  };
}
